/**
 * Global listener for theme:toast:show — used by configurators and universal-variant-picker.
 */
(function () {
  var liveRegion = document.getElementById("theme-toast-live");
  if (!liveRegion) {
    liveRegion = document.createElement("div");
    liveRegion.id = "theme-toast-live";
    liveRegion.className = "sr-only";
    liveRegion.setAttribute("aria-live", "assertive");
    liveRegion.setAttribute("aria-atomic", "true");
    document.body.appendChild(liveRegion);
  }

  document.documentElement.addEventListener("theme:toast:show", function (event) {
    var detail = event.detail || {};
    var message = detail.message || "Something went wrong";
    var tone = detail.tone || "error";

    liveRegion.textContent = message;

    var toast = document.createElement("div");
    toast.className = "banner banner--" + tone + " justify-center";
    toast.setAttribute("role", "alert");
    toast.style.cssText =
      "position:fixed;top:1rem;left:50%;transform:translateX(-50%);z-index:9999;max-width:min(90vw,480px);padding:0.75rem 1.5rem;";
    toast.textContent = message;
    document.body.appendChild(toast);

    window.setTimeout(function () {
      toast.remove();
      liveRegion.textContent = "";
    }, 5000);
  });
})();
